import { useNavigate } from 'react-router-dom';
import { Home } from '@mui/icons-material';
import { home_page, navigateToPage } from '../controls/ProtectedPage';
import NavButton from './NavButton';

const HomeButton = ({ className, isAdmin, ownsSessions }: { className?: string, isAdmin: boolean, ownsSessions: boolean }): JSX.Element => {
    const history = useNavigate();
    return (
        <NavButton
            className={className}
            title="Main landing screen which has your tasks and your sessions all displayed"
            onNavigate={() => navigateToPage(home_page, history, 'summary', true)}
            icon={<Home fontSize='medium' />}
            label={isAdmin && ownsSessions ? 'Sessions' : (isAdmin ? 'Welcome' : 'Session')}
        />

    )
};

export default HomeButton;
